import {
  createContext,
  lazy,
  Suspense,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react'
import {
  showSubscriptionModal,
  closeSubscriptionModal,
  useSubscriptionModalRequest,
  type SubscriptionModalRequest,
} from './subscription-modal-emitter'
const SubscriptionAccessDialogView = lazy(async () => ({
  default: (await import('./SubscriptionAccessDialogView'))
    .SubscriptionAccessDialogView,
}))

function useHasOpened(open: boolean) {
  const [hasOpened, setHasOpened] = useState(open)
  if (open && !hasOpened) setHasOpened(true)
  return open || hasOpened
}

const GlobalSubscriptionHost = createContext(false)
export function SubscriptionModalProvider({
  children,
}: {
  children: ReactNode
}) {
  const request = useSubscriptionModalRequest()
  const hasOpened = useHasOpened(request !== null)
  useEffect(() => () => closeSubscriptionModal(), [])
  return (
    <GlobalSubscriptionHost value={true}>
      {children}
      {hasOpened ? (
        <Suspense fallback={null}>
          <SubscriptionAccessDialogView
            {...request}
            onClose={closeSubscriptionModal}
            open={request !== null}
          />
        </Suspense>
      ) : null}
    </GlobalSubscriptionHost>
  )
}
export function SubscriptionAccessDialog(
  props: SubscriptionModalRequest & { open: boolean; onClose: () => void },
) {
  const global = useContext(GlobalSubscriptionHost)
  const hasOpened = useHasOpened(!global && props.open)
  const { open, onClose, message, details, title, restriction } = props
  useEffect(() => {
    if (!global || !open) return
    return showSubscriptionModal({
      onClose,
      message,
      details,
      title,
      restriction,
    })
  }, [global, open, onClose, message, details, title, restriction])
  return global || !hasOpened ? null : (
    <Suspense fallback={null}>
      <SubscriptionAccessDialogView {...props} />
    </Suspense>
  )
}
